import { useCallback, useState } from 'react';
import restApi from '../lib/restApi';
import { DEFAULT_LOCATION } from '../constants';

const useGeo = ({ setNotificationBar }) => {
  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState();

  const blockedGeoNotification = useCallback(() => {
    setNotificationBar({
      show: true,
      message:
        'You’ve successfully turned off Use My Location. Please enter your location manually.',
      duration: 10000,
    });
  }, [setNotificationBar]);

  const outOfAreaNotification = useCallback(() => {
    setNotificationBar({
      show: true,
      message:
        'Whoops, looks like you’re out of area. We’ve redirected you to the closest listed location near you.',
      duration: 10000,
    });
  }, [setNotificationBar]);

  const fetchGeo = useCallback(
    callback => {
      setLoading(true);

      const success = ({ coords: { latitude, longitude } }) => {
        const fetchData = async () => {
          const { nearest_suburb: nearestSuburb } = await restApi(
            'FindNearestSuburb',
            {
              params: { lat: latitude, lon: longitude },
            }
          );
          if (callback) callback();
          setLoading(false);
          setLocation(nearestSuburb);
          if (nearestSuburb.fallback) {
            outOfAreaNotification();
          }
        };
        fetchData();
      };

      const error = () => {
        blockedGeoNotification();
        setLocation(DEFAULT_LOCATION);
        if (callback) callback();
        setLoading(false);
      };

      navigator.geolocation.getCurrentPosition(success, error, {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      });
    },
    [blockedGeoNotification, outOfAreaNotification]
  );

  return { location, fetchGeo, loading };
};

export default useGeo;
